import { useAppDispatch, useAppSelector } from '../store/hooks';
import { useCallback, useEffect } from 'react';
import { DeploymentModel } from '../models/deploymentModel';
import {
  selectAllDeployments
, selectErrorsForDeployments
, selectIsLoadingDeployments
} from '../store/deployments/deploymentsSelector';
import { fetchAllDeployments } from '../store/deployments/deploymentsActions';
import { AppError } from '../types/appError';

export const useDeploymentList = (): [
  { deployments: DeploymentModel[], isLoading: boolean, errors: AppError[] },
  { refreshAll: () => void },
] => {
  const dispatch = useAppDispatch();
  const deployments = useAppSelector(selectAllDeployments);
  const isLoading = useAppSelector(selectIsLoadingDeployments);
  const errors = useAppSelector(selectErrorsForDeployments);

  const fetchDeployments = useCallback(() => {
    dispatch(fetchAllDeployments());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllDeployments());
  }, [dispatch]);

  return [
    { deployments, isLoading, errors },
    { refreshAll: fetchDeployments },
  ];
};
